<template>
  <div class="container ">
    <div class="article-container" v-if="articleDetail.title">
      <h3 v-if="articleDetail.title && showTitle">{{articleDetail.title}}</h3>
      <div class="p-title-div" v-if="articleDetail.title && showTitle">
      </div>
      <img class="article-pic" :src="articleDetail.blogPic" v-if="showImg"/>
      <div class="article">
        <div   v-html="articleDetail.content"></div>
      </div>
    </div>
  </div>

</template>
<script>
import api from "../api/api";

export default {
    name: 'articleDetail',
    components: {
    },
  //menu  主要需要typeId
    props: {
      typeId: {
        type: Number,
        default: null
      },
      showImg: {
        type: Boolean,
        default: true
      },
      showTitle: {
        type: Boolean,
        default: true
      },
    },
    data() {
        return {
            tags: [],
            activeName: '',
            articleDetail: {}
        }
    },
    watch: {
      typeId: {
        handler(newVal) {
          this.getData()
        }
      },
    },
    mounted() {
      this.getData()
    },
    methods: {
        getData(){
          this.articleDetail = {}
          api.getAriticle({ language: this.$store.state.lang,typeId:this.typeId }).then(res =>{
            let list = res.data.data
            if(list && list.length > 0){
              this.articleDetail = list[0]
              this.articleDetail.content =  this.replaceImgStyle(this.articleDetail.content)
            }
          })
        },
        replaceImgStyle(str){
          // return str.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/g,'').replace(/&nbsp;/ig,'').replace('<p></p>','');
          return str.replace('<img', '<img style=" max-width: 100%; margin: auto;" ');
        },
    }
}
</script>
<style scoped >
.article-container{
  margin-top: 20px;
}
.p-title-div {
  margin: 15px
}
.article-pic{
  width: 100%;
}
.article{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.article > div{
  margin: 20px 0 ;
  width: 100%;
}
@media screen and (max-width: 997px) {
  .article-container {
    margin-top: 10px;
  }
  .article > div {
    margin: 10px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/articleDetail.vue